import { render, staticRenderFns } from "./onsite-reservation.vue?vue&type=template&id=45d0309d&scoped=true"
import script from "./onsite-reservation.vue?vue&type=script&lang=js"
export * from "./onsite-reservation.vue?vue&type=script&lang=js"
import style0 from "./onsite-reservation.vue?vue&type=style&index=0&id=45d0309d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0309d",
  null
  
)

export default component.exports